"use strict";

exports.__esModule = true;
exports.default = navigator && /(iPhone|iPad|iPod)/i.test(navigator.userAgent);


//////////////////
// WEBPACK FOOTER
// ./node_modules/sono/core/utils/iOS.js
// module id = 152
// module chunks = 0